/* eslint-disable import/no-extraneous-dependencies */
import { SexoBiologico } from "screens/perfilAutonomo/utils";
import { date, nativeEnum, z } from "zod";

const commonString = (errorMessage: string): z.ZodString =>
  z.string().min(1, errorMessage);

const phoneValidation = z
  .string()
  .regex(/^[0-9]*$/, "Somente números")
  .max(13, "Telefone inválido");

const dadosFilho = z.object({
  nome: z.string().max(100).optional(),
  dataNascimento: date().nullable().optional(),
  sexo: nativeEnum(SexoBiologico).optional(),
});

export const schema = z
  .object({
    celularPessoal: phoneValidation,
    celularComercial: phoneValidation,
    emailPessoal: z.string().email("Email inválido"),
    nomeEmergencia: commonString("Obrigatório"),
    telefoneEmergencia: phoneValidation,
    tipoContatoEmergencia: z.string().max(100).optional(),
    temFilhos: z.boolean({ required_error: "Obrigatório" }),
    quantidadeFilhos: z.number().max(10).optional(),
    filhos: z.array(dadosFilho, { required_error: "Obrigatório" }),
  })
  .refine(
    (data) => {
      if (data.temFilhos) {
        return !!data.quantidadeFilhos;
      }
      return true;
    },
    {
      message: "Obrigatório",
      path: ["quantidadeFilhos"],
    }
  )
  .refine(
    (data) => {
      if (
        data.temFilhos &&
        data?.quantidadeFilhos &&
        data?.quantidadeFilhos > 0
      ) {
        return data.filhos.every((filho) => {
          return (
            filho.dataNascimento &&
            filho.nome?.trim() !== "" &&
            filho.sexo !== undefined
          );
        });
      }
      return true;
    },
    {
      path: ["filhos"],
    }
  );

export type DadosPessoaisSchema = z.infer<typeof schema>;
